import { CartItem } from '../../types/cart'
import { RoomForSearch } from '../../types/searchAvailability'

export const transformRoomsWithCart = (
  rooms: RoomForSearch[],
  cartItems: CartItem[]
): RoomForSearch[] =>
  rooms.map((room) => ({
    ...room,
    ratePlans: room.ratePlans.map((rp) => {
      const matchingItem = cartItems.find((item) => item.hash === rp.hash)
      return {
        ...rp,
        count: matchingItem?.quantity || 0
      }
    })
  }))
